// VIP加盟商合作协议
let textList = {
  title: '消费者（VIP资格）服务协议',
  content:[
    {
      text: '',
      subText: [
        {
          text: '请您仔细阅读以下条款，如果您对本协议的任何条款表示异议，您可以选择不成为云柑社区平台VIP资格的消费者。'
        }
      ]
    },
    {
      text: '一、相关定义',
      subText: [
        {
          text: '1、社区：社区的划分以物业为单位，包含办公园区、生活社区、商业社区、旅游景区和院校园区。',
        },
        {
          text: '2、云店：平台支持分销版云店、单店版云店、连锁版云店和商圈版云店。'
        },
        {
          text: '3、周边商圈：社区周边500米范围内的快消品、餐饮类商户及周边3公里范围内的服务类、教育类商户。'
        },
        {
          text: '4、商家：社区内的业主、租客或企业可以在云柑社区平台上开店，即可成为商家，租客或企业的租赁合同期限须为半年以上，商家可在云柑社区平台上开设知识店、商品店和服务店三种店铺。'
        },
        {
          text: '5、云柑云豆：是平台用户权益奖励的积分，基于用户购买消费或渠道招商的方式获得，发行总数量为10亿枚，可享受分红。'
        },
        {
          text: '6、VIP资格：消费1000元云柑云店的爆款精选商品即可成为VIP资格的消费者，个人或企业均可，有效期五年。'
        },
      ]
    },
    {
      text: '二、项目介绍',
      subText: [
        {
          text: '云柑社区是以乡村特产、乡村旅游为主，与城市社区、社会组织进行需求对接，创造信息价值，带来经济效应，实现乡村振兴、城乡融合。（以下统称为“本平台”）'
        }
      ]
    },
    {
      text: '三、消费者的权益',
      subText: [
        {
          text: '1、获得VIP资格需要在线上消费1000元云柑云店的爆款精选商品，消费后不可退还。'
        },
        {
          text: '2、消费后即刻成为云柑社区平台的VIP资格的消费者，同时获得云柑优品旗舰店爆款精选商品的1000元提货卡券凭证，用于云柑优品旗舰店的爆款精选商品提货，有效期三年；'
        },
        {
          text: '3、直推其他消费者可按平台推广政策享受直推消费奖励、服务分润奖励及云柑云豆奖励；'
        },
        {
          text: '4、可获得平台赠送的500枚云柑云豆，获得年度分红奖励和权益奖励；',
        },
        {
          text: '5、云柑社区平台赠送1个云店。'
        }
      ]
    },
    {
      text: '四、消费者的责任与义务',
      subText: [
        {
          text: '1、消费者应积极配合和参与云柑社区的市场推广和平台宣传活动。'
        },
        {
          text: '2、对于用户提出的问题无法解决时，消费者可以向平台申请支持，如因消费者操作失误造成用户损失，由消费者自行承担。'
        },
        {
          text: '3、若消费者在市场造成极坏影响，云柑平台方有权终止服务，同时取消消费者资格。'
        },
      ]
    },
    {
      text: '五、其他',
      subText: [
        {
          text: '1、本协议有效期为五年，自消费之日起生效。'
        },
        {
          text: '2、本协议的最终解释权归云柑社区平台所有，本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本协议产生的争议，均应依照中华人民共和国法律予以处理，并由被告住所地人民法院管辖。'
        }
      ]
    }
  ]
}
export default textList